import { ROLES } from 'constants/userConstants';

export const BACK_BUTTON_TEXT = {
    [ROLES.ADMIN]: 'Back to Jobs',
    [ROLES.CLIENT]: 'Back to Jobs Dashboard',
};
